import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { TPVServices } from "../../../services";
import { TpvTicketSelectedPayIndvPage } from "../tpv-ticket-selected-pay-indv/tpv-ticket-selected-pay-indv";
import { Globals } from "../../../../../globals";
import { ConfigurationServices } from '../../../../configuration/services';
import { TpvTicketDiscountRestaurantticketPage } from '../tpv-ticket-discount-restaurantticket/tpv-ticket-discount-restaurantticket';
import { PrintServices } from '../../../../services/printServices';
import { TpvTicketInviteDiscountElementPage } from '../tpv-ticket-invite-discount-element/tpv-ticket-invite-discount-element';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsServices } from '../../../../services/notificationsServices';

/**
 * Generated class for the TpvTicketSelectedPayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-tpv-ticket-selected-pay',
  templateUrl: 'tpv-ticket-selected-pay.html',
})
export class TpvTicketSelectedPayPage {

  callback: any;
  _viewCtrl: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public loadingCtrl: LoadingController,
    private printServices: PrintServices,
    private translate: TranslateService,
    private notificationsServices: NotificationsServices) {

    this.tpvServices.deleteKeyboard();
    this.tpvServices.keyboard_screen = '0';

    this.callback = this.navParams.get('callback');
    this._viewCtrl= this.navParams.get("_viewCtrl")
  }

  /**********************************************************/
  /*                       FUNCIONES                        */
  /**********************************************************/

  back() {
    this.navCtrl.pop();
  }

  ionViewDidLeave() {
    this.tpvServices.is_in_order = false;
  }

  async pay(type) {
    //limita a no cobrar mas de una vez y cree errores 
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cobrando')
    });
    loadingPopup.present();
    await this.tpvServices.cashTicketPay(type, this.tpvServices.selected_type);
    //opencashdrawer if can
    if (type == 'cash') {
      this.printServices.openCashDrawerByType();
    }
    //interval cancel ticket per neteja ok
    var interval = setInterval(() => {
      this.tpvServices.cancelTicket('clean');
      clearInterval(interval);
    }, 1000);
    this.tpvServices.keyboard_screen = '';
    loadingPopup.dismiss();
    //si lo a vendido un un waiter por comandero 
    if (this.tpvServices.is_in_order) {
      //creamos y enviamos una notificacio a tots els usuaris
      let _notification = {
        'UID_RESTAURANT': this.globals.restaurant_uid,
        'title': this.translate.instant("notification-push-pedido-vendido-comandero-title"),
        'description': this.translate.instant("notification-push-pedido-vendido-comandero-desc-1") + this.tpvServices.tables_array[this.tpvServices.selected_table_tpv_index].name + this.translate.instant("notification-push-pedido-vendido-comandero-desc-2"),
      }
      this.notificationsServices.notificationPushAllRestaurant(_notification);

    }
    this.globals.tourLaunchStep(10);
    this.callback(true,this._viewCtrl).then(()=>{
      this.navCtrl.pop();
   });
  }

  calculate(total, pay) {
    var _return = pay - total;
    if (_return > 0) {
      return _return
    } else {
      return 0;
    }
  }

  openCashDrawer() {
    this.printServices.openCashDrawerByType();
  }

  /**********************************************************/
  /*                         NAVCTRL                        */
  /**********************************************************/

  payIndv() {
    this.navCtrl.push(TpvTicketSelectedPayIndvPage);
  }


  discount() {
    this.navCtrl.push(TpvTicketDiscountRestaurantticketPage, {
      type: 'discount'
    });
  }

  restaurantTicket() {
    this.navCtrl.push(TpvTicketDiscountRestaurantticketPage, {
      type: 'restaurantticket'
    });
  }

  invite() {
    this.navCtrl.push(TpvTicketInviteDiscountElementPage, {
      type: 'invite'
    });
  }

  lineDiscount() {
    this.navCtrl.push(TpvTicketInviteDiscountElementPage, {
      type: 'discount'
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-pay/tpv-ticket-selected-pay.ts